import HeroSection from './HeroSection';
import fiscailogo from './fiscai-logo.png';
import './App.css';

function App() {
  return (
<div className="App">
      <HeroSection />
    </div>
  );
}

export default App;
